import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOpt"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H8.58032L16.5803 18H21V20H15.4197L7.41968 6H3V4ZM15 4H21V6H15V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOpt;
